import { Option } from '~/@/components/inputs/selection/utils'
import { EnumOption } from '~/common/generated/apollo-operations'
import { ResolvedOptionColor, resolveEnumOptionColor } from '~/common/styles/enum-colors'

/** The subset of an EnumOption the render surfaces need */
export type EnumOptionLite = Pick<
  EnumOption,
  'id' | 'label' | 'colorPreset' | 'colorCustom' | 'iconName' | 'order'
>

/** A single value ready to render */
export interface EnumValueMark {
  label: string
  /** Resolved palette for the option; null or absent renders the neutral (uncolored) value */
  color?: ResolvedOptionColor | null
  iconName?: string | null
}

/** Resolves a cell/selection value to its option's color + icon within an option set */
export const getEnumValueColorAndIcon = (
  value: string,
  options: EnumOptionLite[] | null | undefined,
): { color: ResolvedOptionColor | null; iconName: string | null } => {
  const option = options?.find((o) => o.label === value)
  return {
    color: option ? resolveEnumOptionColor(option.colorPreset, option.colorCustom) : null,
    iconName: option?.iconName ?? null,
  }
}

/** Builds dropdown `Option`s for an enum column, in set order with each option's color and icon */
export const buildEnumDropdownOptions = (
  setOptions: EnumOptionLite[] | null | undefined,
): Option[] =>
  [...(setOptions ?? [])]
    .sort((a, b) => a.order - b.order)
    .map((option) => ({
      value: option.label,
      label: option.label,
      color: resolveEnumOptionColor(option.colorPreset, option.colorCustom),
      iconName: option.iconName,
    }))
